<section class="IndexPage">
  <div class="container">
    <header class="IndexPage__header">
      <h4 class="IndexPage__title">{{ config.header.title }}</h4>

      <div class="IndexPage__portals">
        @for (portal of config.header.portals; track portal) {
          <zip-button
            class="IndexPage__portal"
            [config]="{
              level: 'medium',
              icon: 'open_in_new',
              isIconRight: true,
              content: portal.label,
            }"
          >
          </zip-button>
        }
      </div>
    </header>

    <div class="IndexPage__columns">
      @for (column of config.columns; track column) {
        <section class="IndexPage__column">
          @for (card of column.cards; track card) {
            <div class="IndexPage__card">
              @for (group of card.groups; track group) {
                <div class="IndexPage__group">
                  <h6 class="IndexPage__label">{{ group.label }}</h6>
                  @for (view of group.views; track view) {
                    <div class="IndexPage__view">
                      <zip-button
                        [config]="{
                          level: 'high',
                          content: view.label,
                          size: 'fullWidth',
                        }"
                      >
                      </zip-button>
                      <div>
                        @for (action of view.actions; track action) {
                          <zip-button
                            [config]="{
                              level: 'medium',
                              content: action.label,
                              size: 'fullWidth',
                            }"
                          >
                          </zip-button>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </section>
      }
    </div>
  </div>
</section>
